import { BE_LIMIT_TYPE, DELIMITER_GAME, MAX_VALUE } from '~/components/Limits/constants'
import { createState } from '~/util/storeHelpers'

const limitsInfo = createState({ key: 'limitsInfo', initialValue: null })
const updateLimit = createState({ key: 'updateLimit', initialValue: {} })
export const state = () => ({
  limitsInfo: limitsInfo.state,
  gamePause: null,
  gameExceededLimits: null,
  updateLimit: updateLimit.state,
})

export const mutations = {
  set_limitsInfo: limitsInfo.setter,
  set_updateLimit: updateLimit.setter,
  set_limitsGamePause(state, payload) {
    state.gamePause = payload
  },
  set_gameExceededLimits(state, payload) {
    state.gameExceededLimits = payload
  },
}

export const actions = {
  act_gameExceededLimits({ commit }, payload) {
    commit('set_gameExceededLimits', payload)
  },
  act_limitsGamePause({ commit }, payload) {
    commit('set_limitsGamePause', payload)
  },
  actReset_limitsInfo({ commit }) {
    commit('set_limitsInfo', { reset: true })
  },
  async act_getUserLimits({ commit, getters }) {
    try {
      if (getters.get_limitsInfo.isLoading) return
      commit('set_limitsInfo', { isLoading: true })
      const { data } = await this.$api.userLimits.list()
      commit('set_limitsInfo', { data: data.result })
    }
    catch (e) {
      console.log(e)
    }
    finally {
      commit('set_limitsInfo', { isLoading: false })
    }
  },
  async act_postUserLimit({ commit }, { type, limit, delimiter }) {
    try {
      commit('set_updateLimit', { isLoading: true })
      const res = await this.$api.userLimits.update({ type, limit, delimiter })
      if (res.data?.status) {
        commit('set_updateLimit', { data: res.data, error: null })
      }
      else {
        commit('set_updateLimit', { data: null, error: res.data })
      }
      return res
    }
    catch (error) {
      commit('set_updateLimit', { error, data: null })
      console.warn({ error })
    }
    finally {
      commit('set_updateLimit', { isLoading: false })
    }
  },
}

export const getters = {
  get_limitsInfo: limitsInfo.getter,
  get_limits: (_, getters) => getters.get_limitsInfo.data?.limits || [],
  get_limitsIsLoaded: (state) => !!state.limitsInfo.data,
  get_isLimitsHasBeenSet: (_, getters) => {
    return getters.get_limitsDepositObj.isActive
      && getters.get_limitsGameDayObj.isActive
      && getters.get_limitsGameWeekObj.isActive
  },
  get_limitsIsEnabled: (_, getters) => getters.get_limitsInfo.data?.is_enabled,
  get_limitsDepositObj: (_, getters) => {
    const limitObj = getters.get_limits.find(l => l.type === BE_LIMIT_TYPE.DEPOSIT)
    if (!limitObj) return {}
    return {
      isDeposit: true,
      isActive: !!limitObj._id,
      isUnLim: limitObj.limit === +MAX_VALUE.UN_LIM,
      isDisabled: !limitObj.is_applied_for_changes,
      ...limitObj,
    }
  },
  get_limitsGameDayObj: (_, getters) => {
    const limitObj = getters.get_limits.find(l => l.type === BE_LIMIT_TYPE.GAME_SESSION && l.delimiter === DELIMITER_GAME.DAY)
    if (!limitObj) return {}
    return {
      isGameDay: true,
      isActive: !!limitObj._id,
      isUnLim: limitObj.limit === +MAX_VALUE.UN_LIM,
      isDisabled: !limitObj.is_applied_for_changes,
      ...limitObj,
    }
  },
  get_limitsGameWeekObj: (_, getters) => {
    const limitObj = getters.get_limits.find(l => l.type === BE_LIMIT_TYPE.GAME_SESSION && l.delimiter === DELIMITER_GAME.WEEK)
    if (!limitObj) return {}
    return {
      isGameWeek: true,
      isActive: !!limitObj._id,
      isUnLim: limitObj.limit === +MAX_VALUE.UN_LIM,
      isDisabled: !limitObj.is_applied_for_changes,
      ...limitObj,
    }
  },
  get_limitsGamePause: (state) => state.gamePause,
  get_gameExceededLimits: (state) => state.gameExceededLimits,
  get_updateLimit: updateLimit.getter,
}
